// tslint:disable
export enum EmailErrorCode {
    /**
     * @description No Error
     */
    NoError = 0,
    /**
     * @description User Id Not Found
     */
    UserIdNotFound = 1,
    /**
     * @description Bronto Error
     */
    BrontoError = 2,
    /**
     * @description General Error
     */
    GeneralError = 3,
    /**
     * @description Warning
     */
    Warning = 100,
}
(EmailErrorCode as any)['NOERROR'] = 0;
(EmailErrorCode as any)['USERIDNOTFOUND'] = 1;
(EmailErrorCode as any)['BRONTOERROR'] = 2;
(EmailErrorCode as any)['GENERALERROR'] = 3;
(EmailErrorCode as any)['WARNING'] = 100;
